'use es6';

import { GLOBAL_NULL } from '../constants/defaultNullValues';

// https://git.hubteam.com/HubSpot/reporting/blob/master/reporting-data/static-1.58248/js/dataTypeDefinitions/inboundDb/contacts.js#L63
export const generateAnalyticsSourceData2Label = (sourceInfo, key) => {
  const label = sourceInfo.get('label');
  return !label && key === GLOBAL_NULL ? null : label || key;
};